class MHeader extends HTMLElement{constructor(){super(),this.selectors={headers:["header"],logos:[".m-logo"],topbar:".m-topbar",headerWrapper:".m-header__wrapper",topbarClose:".m-topbar__close"},this.domNodes=queryDomNodes(this.selectors,this),this.innerWidth=window.innerWidth,this.headerOffsetTop=this.domNodes.headerWrapper.offsetTop,this.headerHeight=this.domNodes.headerWrapper.offsetHeight,this.stickyEnabled="true"===this.dataset.sticky||!1,this.classes={scrollUp:"scroll-up",scrollDown:"scroll-downs",stuck:"stuck"},this.init()}init(){this.transparentHeader=this.domNodes&&this.domNodes.headers[0]&&"true"===this.domNodes.headers[0].dataset.transparent,this.initAddon(),this.handleSticky(),document.addEventListener("matchMobile",(()=>this.handleSticky())),document.addEventListener("unmatchMobile",(()=>this.handleSticky())),this.siteNav=new SiteNav(this),window.__sfHeader=this,window.addEventListener("resize",(()=>{this.innerWidth=window.innerWidth})),this.transparentHeader&&this.innerWidth>1280?this.domNodes.headerWrapper&&this.domNodes.headerWrapper.classList.add("transparent-on-top"):this.domNodes.headerWrapper&&this.domNodes.headerWrapper.classList.remove("transparent-on-top")}initAddon(){this.megamenu=new Megamenu(this),Shopify.designMode&&(MinimogTheme=MinimogTheme||{},MinimogTheme&&MinimogTheme.Wishlist&&MinimogTheme.Wishlist.updateWishlistCount())}handleSticky(){let s=20;document.querySelectorAll(".shopify-section-group-header-group").forEach((e=>{e.classList.contains("m-section-header")||(s+=e.offsetHeight)}));const e=document.querySelector(".m-topbar");if(e&&(s+=e.offsetHeight),!this.stickyEnabled)return;let t=0;window.addEventListener("scroll",(()=>{const e=window.scrollY;if(e<=s)return this.classList.remove(this.classes.scrollUp,this.classes.stuck),void(this.transparentHeader&&this.innerWidth>1279&&this.domNodes.headerWrapper&&this.domNodes.headerWrapper.classList.add("transparent-on-top"));this.classList.add(this.classes.stuck),e>this.headerHeight+s&&e>t&&!this.classList.contains(this.classes.scrollDown)?(this.classList.remove(this.classes.scrollUp),this.classList.add(this.classes.scrollDown)):e<t&&this.classList.contains(this.classes.scrollDown)&&(this.classList.remove(this.classes.scrollDown),this.classList.add(this.classes.scrollUp),this.transparentHeader&&this.innerWidth>1279&&this.domNodes.headerWrapper&&this.domNodes.headerWrapper.classList.remove("transparent-on-top")),t=e}))}}customElements.define("m-header",MHeader);




// Mobile Menu Toggle Script
document.addEventListener('DOMContentLoaded', function() {
  // Toggle submenu on click (both link and arrow)
  const toggleElements = document.querySelectorAll('[data-toggle="submenu"]');
  
  toggleElements.forEach(element => {
    element.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Find the parent menu item
      const parentItem = this.closest('.m-menu-mobile__item');
      if (!parentItem) return;
      
      // Find the submenu wrapper
      const submenuWrapper = parentItem.querySelector('.m-submenu-wrapper');
      if (!submenuWrapper) return;
      
      // Toggle the active class on the submenu wrapper
      submenuWrapper.classList.toggle('active');
      
      // Find all toggle buttons in this item and toggle their active class
      const toggleButtons = parentItem.querySelectorAll('[data-toggle="submenu"]');
      toggleButtons.forEach(btn => {
        btn.classList.toggle('active');
      });
      
      // If submenu is now active, show it; otherwise hide it
      if (submenuWrapper.classList.contains('active')) {
        submenuWrapper.style.display = 'block';
      } else {
        submenuWrapper.style.display = 'none';
      }
    });
  });
  
  // Close other submenus when one is opened
  document.querySelectorAll('.m-menu-mobile__item--has-submenu').forEach(item => {
    const toggleElements = item.querySelectorAll('[data-toggle="submenu"]');
    const submenuWrapper = item.querySelector('.m-submenu-wrapper');
    
    toggleElements.forEach(toggleEl => {
      toggleEl.addEventListener('click', function(e) {
        // Close all other submenus at the same level
        const parentList = item.closest('ul');
        if (parentList) {
          parentList.querySelectorAll('.m-menu-mobile__item--has-submenu').forEach(otherItem => {
            if (otherItem !== item) {
              const otherSubmenu = otherItem.querySelector('.m-submenu-wrapper');
              const otherToggles = otherItem.querySelectorAll('[data-toggle="submenu"]');
              
              if (otherSubmenu) {
                otherSubmenu.classList.remove('active');
                otherSubmenu.style.display = 'none';
              }
              otherToggles.forEach(btn => {
                btn.classList.remove('active');
              });
            }
          });
        }
      });
    });
  });
});